export default "__VITE_ASSET__DmQEC2uQ__"